import { minWidth } from 'helpers/buildMediaQueries';
import styled from 'styled-components';
import {
  gutterVariables,
  colorsVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const SearchOptions = styled.div`
  text-align: center;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${gutterVariables.GUTTER_ONE_QUARTER};
    min-height: 46px;
    font-size: 20px;
    text-align: center;
    ${minWidth('md', 'padding: 0 36px;')}
    white-space: nowrap;

    text-decoration: none;

    &,
    &:visited {
      color: ${colorsVariables.BLUE_700};
    }

    &:hover {
      cursor: pointer;
      text-decoration: none;
      color: ${colorsVariables.BLUE_600};
    }
  }

  .hls {
    line-height: inherit;
    margin-left: ${gutterVariables.GUTTER_ONE_QUARTER};

    :before {
      line-height: inherit;
    }
  }
`;
